import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TreeNodeBuilder } from '../../../models/structures/tree';
import { ComponentTreeNode, TreeNodeData } from './tree.component';

@Injectable()
export class TreeBuilder {
  dataChange = new BehaviorSubject<ComponentTreeNode[]>([]);
  treeData: ComponentTreeNode[];

  initialize(tree: ComponentTreeNode[]) {
    this.dataChange.next(tree);
    this.treeData = this.dataChange.value;
  }

  get data(): ComponentTreeNode[] {
    return this.dataChange.value;
  }

  // filter(filterText: string) {
  //   this.treeData.forEach(treeNode => {
  //     treeNode.traverseBF(node => this.filterTraverse(node, filterText));
  //   });

  //   this.dataChange.next(this.treeData);
  // }

  /**
   * Search the text in the tree.
   * @param filterText Filter text to search
   */
  filter(filterText: string) {
    let filteredTreeData: ComponentTreeNode[] = [];
    if (filterText) {
      filteredTreeData = this.search(this.treeData, filterText);
    } else {
      filteredTreeData = this.treeData;
    }
    this.dataChange.next(filteredTreeData);
  }

  /**
   * Return text without accent, normalize the text
   * @param text Input text
   */
  normalize(text: string) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  /**
   * Return true if filter text is in text
   * @param text Text to compare
   * @param filterText Text to filter
   */
  compareText(text: string, filterText: string): boolean {
    const textNormalize = this.normalize(text).toLowerCase();
    const filterNormalize = this.normalize(filterText).toLowerCase();
    return textNormalize.indexOf(filterNormalize) >= 0;
  }

  /**
   * Returns the tree node array with the result
   * @param items Array to search
   * @param filterText Filter text
   */
  search(items: ComponentTreeNode[], filterText: string): ComponentTreeNode[] {
    return items.reduce((accumulator: ComponentTreeNode[], node) => {
      if (this.compareText(node.getData().title, filterText)) {
        accumulator.push(node);
      } else if (node.getChildren() && node.getChildren().length > 0) {
        const newItems = this.search(node.getChildren(), filterText);
        if (newItems.length > 0) {
          let newNode = new TreeNodeBuilder<TreeNodeData>()
            .withId(node.getId())
            .withChildren(newItems)
            .withParent(node.getParent())
            .withData(node.getData())
            .build();
          accumulator.push(newNode);
        }
      }
      return accumulator;
    }, []);
  }
}
